import * as firebase from "firebase/app";
import { manejarCambiosFirebase } from './utilidades.js'

var estado = {
	firebase: null,
	firestore: null,
	cuenta: {
		identificador: ''
	},
	inicializarTemporal: function(fb, fs, ct) {
		this.firebase = fb
		this.firestore = fs
		this.cuenta = ct
	},
	// El siguiente deberá reemplazar al anterior
	/*inicializar: function() {
		this.firebase = firebase.initializeApp({
			apiKey: "AIzaSyD6QL2Giq9ApR__x6KboHzDtraE7k4h-o0",
			authDomain: "sitios-c19fc.firebaseapp.com",
			databaseURL: "https://sitios-c19fc.firebaseio.com",
			projectId: "sitios-c19fc",
			storageBucket: "sitios-c19fc.appspot.com",
			messagingSenderId: "203722643069",
			appId: "1:203722643069:web:f19fafbb2f30785e018314"
		})

		this.firestore = this.firebase.firestore();
	}*/
	desconectar: function() {
		if (archivos.escuchaListado) {
			archivos.escuchaListado()
		}
	}
}

var archivos = {
	inicializando: false,
	inicializado: false,
	listado: [],
	escuchaListado: null,
	listadoImágenes: [],
	inicializar: function() {
		if (this.inicializado || this.inicializando) {
			return
		}

		this.inicializando = true
		this.escuchaListado = estado.firestore.collection('cuentas').doc(estado.cuenta.identificador).collection('archivos').onSnapshot( snapshot => {
			manejarCambiosFirebase(this.listado, snapshot)
			manejarCambiosFirebase(this.listadoImágenes, snapshot, function(change){
				return change.doc.data().tipo === 'imagen'
			})

			this.inicializando = false
			this.inicializado = true
		}, err => {
			this.inicializando = false
			console.error('[4739]', err)
			window.alert('[4739] Ocurrió un error.')
		})
	}
}

export { estado, archivos }